/*
  
*/
var Filter = require('./refiner').Filter;

exports.Refiner = function UnlikelyFormatFilter() {
    Filter.call(this);
    

    this.isValid = function(text, result, opt) { 

        if (result.text.replace(' ','').match(/^\d*(\.\d*)?$/)) {
            return false;
        }

        return true; 
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/chrono-node/src/refiners/UnlikelyFormatFilter.js
// module id = 1103
// module chunks = 0